<template>
  <div>
    <b-form-select :options="options" v-model="compValue" :disabled="readonly">
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "CargoExpenseResponsabilityDropdown",
  props: {
    value: Number,
    readonly: Boolean,
  },
  data() {
    return {
      options: [
          { value: 1, text: this.$t("geral.company") },
          { value: 2, text: this.$t("geral.client") }
      ],
    };
  },
  computed: {
    compValue: {
      get: function () {
        if (this.options) {
          return this.value;
        }
        return null;
      },
      set: function (newValue) {
        this.$emit("update:value", parseInt(newValue));
      },
    }
  }
};
</script>
